import { configuracaoCadastroProdutos, preferenciasCadastroProdutos } from './productRegistrationSettings'
import { normalizarComplementoProduto } from '@/utils/produtoOperacoes'

const chave = (empresa, area) => `escalador:produtos:v1:${empresa}:${area}`

export function lerProdutosLocal(empresa, area, padrao = []) {
  try { return JSON.parse(localStorage.getItem(chave(empresa, area))) ?? padrao } catch { return padrao }
}

export function salvarProdutosLocal(empresa, area, dados) {
  if (!empresa) throw new Error('Selecione a empresa antes de salvar.')
  localStorage.setItem(chave(empresa, area), JSON.stringify(dados))
}

export function carregarExtensaoProduto(empresa, produto = {}) {
  const operacoesApi = produto.operacoesProduto || {}
  const lotesApi = Array.isArray(produto.lotes) ? { lotes: produto.lotes } : {}
  const movimentosLotesApi = Array.isArray(produto.movimentosLotes) ? { movimentosLotes: produto.movimentosLotes } : {}
  const conversoesApi = Array.isArray(produto.conversoes) ? { conversoes: produto.conversoes } : {}
  const base = { ...operacoesApi, ...lotesApi, ...movimentosLotesApi, ...conversoesApi }
  if (Object.keys(base).length > 0) {
    return normalizarComplementoProduto(base)
  }
  const local = empresa && produto.id ? lerProdutosLocal(empresa, `produto:${produto.id}`, null) : null
  return normalizarComplementoProduto(local || base)
}

export const lerPreferenciasProdutos = empresa => {
  const salvas = lerProdutosLocal(empresa, 'preferencias', {})
  return { chave: 'TODAS', ...salvas, ...preferenciasCadastroProdutos(configuracaoCadastroProdutos({}, salvas)) }
}

export function salvarPreferenciasProdutos(empresa, dados) {
  salvarProdutosLocal(empresa, 'preferencias', { ...lerPreferenciasProdutos(empresa), ...dados })
}

